<template>
    <div id="pageCard">
        <v-container grid-list-xl fluid>
            <v-layout>
                <v-flex sm12>
                    <h3>فروشگاه ها</h3>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 md4>
                    <v-card @click="$router.push(`/pages/store/add/`)">
                        <v-img src="/static_reseller/bg/create_your_store.jpg" height="250">
                        </v-img>
                        <v-card-text>
                            <v-btn icon fab color="red" dark class="right mt-45">
                                <v-icon>add</v-icon>
                            </v-btn>
                            <div>
                                &nbsp;&nbsp;&nbsp;
                            </div>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-btn flat small>ایجاد فروشگاه جدید</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
                <v-flex
                    :key="store.id"
                    v-for="(store,_) in stores"
                    xs12 md4>
                    <v-card @click="$router.push(`/pages/store/edit/` +store.shop_id)">
                        <v-img :src="`https://chapchi.com/stores/picture_` + store.shop_id + `.png`" height="250">
                        </v-img>
                        <v-card-text>
                            <v-btn icon fab color="blue" dark class="right mt-45">
                                <v-icon>edit</v-icon>
                            </v-btn>
                            <div>
                                {{store.shop_name}}
                            </div>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-btn flat small>مدیریت</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>

            <v-snackbar
                    :timeout="snackbar.timeout"
                    :color="snackbar.color"
                    :top="snackbar.y === 'top'"
                    :bottom="snackbar.y === 'bottom'"
                    :right="snackbar.x === 'right'"
                    :left="snackbar.x === 'left'"
                    :multi-line="snackbar.mode === 'multi-line'"
                    :vertical="snackbar.mode === 'vertical'"
                    v-model="snackbar.snackbar"
            >
                {{ snackbar.text }}
                <v-btn flat icon dark @click.native="snackbar.snackbar = false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-snackbar>
        </v-container>
    </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import HttpErrorToSnackbar from '@/api/HttpErrorToSnackbar';
export default {
  components: {
    VWidget
  },
  data () {
    return {
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
      stores: []
    };
  },
  computed: {
  },
  created: function () {
    this.axios.get('/reseller/stores/')
      .then(response => {
        this.stores = response.data.Data;
      })
      .catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });
  },
  methods: {
  }
};
</script>
<style lang="stylus" scoped>
    .mt-45
        margin-top: -45px
    .mt-56
        margin-top: -56px
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue